// Opens the Oma riista app (Riistakeskus) for the harvest report, or its store page when it isn't installed.
// Oma riista has no API for reporting from other apps, so the report itself is made there.
import { Capacitor } from "@capacitor/core";
import { AppLauncher } from "@capacitor/app-launcher";
import { isNative } from "./native.ts";

const PKG = "fi.riista.mobile";
const PLAY = `https://play.google.com/store/apps/details?id=${PKG}`;
const APP_STORE = "https://apps.apple.com/fi/app/oma-riista/id912777656";
const WEB = "https://oma.riista.fi";

/** Chrome on Android starts the app from this link, or goes to the fallback (the Play page) when it isn't installed. */
const intentUrl = `intent:#Intent;action=android.intent.action.MAIN;category=android.intent.category.LAUNCHER;package=${PKG};` +
  `S.browser_fallback_url=${encodeURIComponent(PLAY)};end`;

export async function openOmaRiista(): Promise<void> {
  const ua = navigator.userAgent;
  if (isNative()) {
    // the plugin is in builds made since 30 Oct 2026; older builds open the Play page, which says "Open" when it's installed
    if (Capacitor.isPluginAvailable("AppLauncher")) {
      try {
        if ((await AppLauncher.canOpenUrl({ url: PKG })).value) { await AppLauncher.openUrl({ url: PKG }); return; }
        await AppLauncher.openUrl({ url: `market://details?id=${PKG}` });
        return;
      } catch { /* falls back to the Play page */ }
    }
    location.href = PLAY;
  } else if (/Android/.test(ua)) location.href = intentUrl;
  // iOS can't tell whether an app is installed; the App Store page shows "Open" when it is
  else if (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) location.href = APP_STORE;
  else window.open(WEB, "_blank", "noopener");
}
